import { render, staticRenderFns } from "./CustomerListPagination.vue?vue&type=template&id=42b1e712&scoped=true&lang=pug"
import script from "./CustomerListPagination.vue?vue&type=script&lang=js"
export * from "./CustomerListPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b1e712",
  null
  
)

export default component.exports